export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [7,[2]],
		"/(app)/account": [8,[2]],
		"/(app)/admin/accounts": [9,[2,3]],
		"/(app)/admin/accounts/[account_id]": [10,[2,3]],
		"/(app)/analytics": [11,[2,4]],
		"/(app)/analytics/automation": [12,[2,4]],
		"/(app)/analytics/reports": [13,[2,4]],
		"/(app)/analytics/tasks": [14,[2,4]],
		"/(app)/analytics/validation": [15,[2,4]],
		"/(app)/api": [16,[2]],
		"/(dev)/dev/components": [31,[6]],
		"/(dev)/dev/components/[slug]": [32,[6]],
		"/(app)/file-system-agent": [17,[2]],
		"/forbidden": [33],
		"/(app)/isometric-showcase": [18,[2]],
		"/(app)/ops/loanlogics": [19,[2]],
		"/(app)/projects": [20,[2]],
		"/(app)/projects/library": [26,[2]],
		"/(app)/projects/[project_id]": [21,[2,5]],
		"/(app)/projects/[project_id]/about": [22,[2,5]],
		"/(app)/projects/[project_id]/automation": [23,[2,5]],
		"/(app)/projects/[project_id]/configuration": [24,[2,5]],
		"/(app)/projects/[project_id]/validation": [25,[2,5]],
		"/(app)/status": [27,[2]],
		"/(app)/tasks": [28,[2]],
		"/(app)/usage": [29,[2]],
		"/(app)/users": [30,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';